import { Injectable } from '@angular/core';
import { LookbookApiService } from '@epicuro-next/data/engagement/engagement-api';
import { LookBook } from '@epicuro-next/models/engagement';
import { go } from '@epicuro-next/state/router-store';
import {
  selectAccountId,
  selectSiteId,
} from '@epicuro-next/state/session-state';
import { isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

import { clearShopTheLookEditState } from '../edit';
import { adaptLookBookToSend, shopTheLookPath } from '../utils';

import {
  createLookBook,
  createLookBookError,
  createLookBookNotify,
  createLookBookSuccess,
} from './create-shop-the-look.actions';

@Injectable()
export class CreateShopTheLookEffects {
  constructor(
    private store: Store,
    private actions$: Actions,
    private lookbookAPI: LookbookApiService,
  ) {}

  public createLookBook$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createLookBook),
      concatLatestFrom(() => [
        this.store.pipe(select(selectAccountId), filter(isNonNullish)),
        this.store.select(selectSiteId).pipe(filter(isNonNullish)),
      ]),
      switchMap(([{ lookBook }, accountId, siteId]) =>
        this.lookbookAPI
          .createLookBook({
            ...adaptLookBookToSend(lookBook),
            accountId,
            siteId,
          })
          .pipe(
            switchMap((lookbookOrId) => {
              if (typeof lookbookOrId === 'string') {
                return this.lookbookAPI.getLookBook({
                  queryparams: { lookBookId: lookbookOrId },
                  accountId,
                  siteId: siteId ?? '',
                });
              } else {
                return of(lookbookOrId);
              }
            }),
            switchMap((item) => {
              return [
                createLookBookSuccess({
                  lookBook: item as unknown as LookBook,
                }),
                clearShopTheLookEditState(),
                createLookBookNotify({
                  message: `${lookBook.title ?? 'LookBook'} created.`,
                }),
              ];
            }),
            catchError((error) =>
              of(createLookBookError({ error: error.message })),
            ),
          ),
      ),
    ),
  );

  public createLookBookSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createLookBookSuccess),
      map((action) =>
        go({
          commands: shopTheLookPath([action.lookBook.id]),
        }),
      ),
    ),
  );
}
